
import Select from 'react-select'
import React, { useEffect, useState } from 'react'

import PipeLineMasterPagePopup from './PipelineMasterPagePopup'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { WaterSupplyPipelineExportTableDataAPI, WaterSupplyPipelineMasterDeleteAPI, WaterSupplyPipelineTableDataAPI } from '../../../../../../Redux/WaterSupplyDashBoardSlice/WaterSupplyMasterSlice/WaterSupplyPipelineSlice'
import { Loading } from '../../../../../../Helper/Loading'
import { useSearchParams } from 'react-router-dom'
import { JunctionNameDataDDL } from '../../../../../../Components/CommonDDL/JunctionNameDataDDL'
import { PipelineDataDDL } from '../../../../../../Components/CommonDDL/PipelineDataDDL'
import { DistributionLineLocationDataDDL } from '../../../../../../Components/CommonDDL/DistributionLineLocationDataDDL'
import { PipelineMasterExportData } from './PipelineMasterExportPage'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL'

export default function PipelineMasterPage() {

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [PipelineMasterPopupShow, setPipelineMasterPopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [CurrentPage, setCurrentPage] = useState(0)
    const [PerPageCount, setPerPageCount] = useState(10)
    const [IsClear, setIsClear] = useState(false)
    const [isSearch, setIsSearch] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [rowNo, setrowNo] = useState(1)
    const [FromTop, setFromTop] = useState(1)
    const [ToTop, setToTop] = useState(10)

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")

    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")

    // console.log(DashProjectTypeId)

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [JunctionNameDDL, setJunctionNameDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [Pipeline, setPipeline] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setPipelineMasterPopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setPipelineMasterPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setPipelineMasterPopupShow(false)
    }
    const handleClear = () => {
        setCurrentPage(0)
        setToTop(10)
        setFromTop(1)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
        setPipeline({
            ...Pipeline,
            ID: 0,
            Label: 'Select...',
        })
        setJunctionNameDDL({
            ...JunctionNameDDL,
            ID: 0,
            Label: 'Select...',
        })
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setToTop(10)
        setFromTop(1)
        setIsSearch(!isSearch)
    }

    useEffect(() => {
        const data = {
            M_WS_PipeLineID: Pipeline.ID,
            M_WardID: WardName.ID,
            M_WS_JunctionID: JunctionNameDDL.ID,
            PipelineDetails: '',
            token: token,
            FromTop: FromTop,
            ToTop: ToTop,
            M_UserID: UserID,
            Flag: ApiFlag,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID,
            handleWaterSupplyPipelineExport: handleWaterSupplyPipelineExport
        }
        // if (WardName.ID !== 0) {
            dispatch(WaterSupplyPipelineTableDataAPI({ data }))
        // }
    }, [IsPost, FromTop, isSearch, IsClear, WardName.ID])

    const { tableData, isLoading } = useSelector(state => state.WaterSupplyPipelineTableData)

    const handleWaterSupplyPipelineExport = () => {
        const data = {
            M_WS_PipeLineID: Pipeline.ID,
            M_WardID: WardName.ID,
            M_WS_JunctionID: JunctionNameDDL.ID,
            PipelineDetails: '',
            token: token,
            FromTop: FromTop,
            ToTop: '99999',
            M_UserID: UserID,
            Flag: ApiFlag,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }
        // if (WardName.ID != 0) {
            dispatch(WaterSupplyPipelineExportTableDataAPI({ data }))
        // }
    }
    // , [IsPost, isSearch, IsClear, WardName.ID])

    const { ExportTableData, isExportLoading } = useSelector(state => state.WaterSupplyPipelineExportTableData)

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleDeleteApi = (item) => {
        const data = {
            M_TTP_PipeLineID: item.m_ttP_PipeLineID,
            M_WS_PipeLineID: item.m_wS_PipeLineID,
            M_Distri_WS_PipeLineID: item.m_Distri_WS_PipeLineID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost,
            DashProjectTypeId: DashProjectTypeId,
            RoleID: RoleID
        }
        dispatch(WaterSupplyPipelineMasterDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.WaterSupplyPipelineMasterDelete)

    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName}
            />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='col-5'>
                                <h5 className="mt-2">Pipeline</h5>
                            </div>
                            <div className='col-7 mar_add'>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <PipelineMasterExportData
                                                ExcelData={ExportTableData}
                                                name='Pipeline'
                                                RoleID={RoleID}
                                            // searchName={searchName}
                                            />
                                    }
                                    <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                        style={{ color: "white" }}
                                        onClick={handleAddOnClick}
                                    >
                                        <text className="ml-2 poppins">Add</text>
                                    </i>
                                </div>
                            </div>
                            <div className="row m-0 ">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">

                                        <div className="row py-1 rounded2">

                                            <div className="col-lg-3 col-md-4">
                                                <WardNameDataDDL
                                                    WardName={WardName}
                                                    setWardName={setWardName}
                                                    HWard={HWard}
                                                    WLable={WLable}
                                                    DashProjectTypeId={DashProjectTypeId}
                                                // Flag='ward'
                                                />

                                            </div>

                                            {
                                                ((DashProjectTypeId == '6' && RoleID != '16') || DashProjectTypeId == '9') ?
                                                    <>
                                                        <div className="col-lg-3 col-md-4">
                                                            <DistributionLineLocationDataDDL
                                                                DistributionLineLocationDDL={JunctionNameDDL}
                                                                setDistributionLineLocationDDL={setJunctionNameDDL}
                                                                WardName={WardName}
                                                                DashProjectTypeId={DashProjectTypeId}
                                                            // Flag='ward'
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    <div className="col-lg-3 col-md-4">
                                                        <JunctionNameDataDDL
                                                            JunctionNameDDL={JunctionNameDDL}
                                                            setJunctionNameDDL={setJunctionNameDDL}
                                                            WardName={WardName}
                                                        />

                                                    </div>
                                            }

                                            <div className="col-lg-3 col-md-4">
                                                <PipelineDataDDL
                                                    Pipeline={Pipeline}
                                                    setPipeline={setPipeline}
                                                    JunctionNameDDL={JunctionNameDDL}
                                                    IsPost={IsPost}
                                                    DashProjectTypeId={DashProjectTypeId}
                                                    DistributionLineLocationDDL={JunctionNameDDL}
                                                />
                                            </div>



                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-1">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Ward Name</th>
                                                        {
                                                             ((DashProjectTypeId == '6' && RoleID != '16') || DashProjectTypeId == '9') ?
                                                                <th>Location Name</th>
                                                                :
                                                                <th>Junction Name</th>
                                                        }

                                                        <th>Pipeline Details</th>
                                                        <th className="action_icon action-col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) =>
                                                            <tr>
                                                                <td className="sr-no-col" style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td className='min-w-50'>{item.wardName ? item.wardName : '0'}</td>
                                                                {
                                                                    ((DashProjectTypeId == '6' && RoleID != '16') || DashProjectTypeId == '9') ?
                                                                        <td>{item.locationDetails ? item.locationDetails : '-'}</td>
                                                                        :
                                                                        <td>{item.junctionDetails ? item.junctionDetails : '-'}</td>
                                                                }

                                                                <td className='min-w-100'>{item.pipelineDetails ? item.pipelineDetails : '-'}</td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    <span>
                                                                        <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleEditOnClick(item)}
                                                                        >
                                                                        </i>
                                                                    </span>
                                                                    <span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) :
                                                            <td colSpan={15}>No data found</td>
                                                    }

                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFromTop}
                                                setTo={setToTop}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    PipelineMasterPopupShow ?
                        <PipeLineMasterPagePopup
                            open={PipelineMasterPopupShow}
                            popupHeading="Pipe Line"
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                            WardName={WardName}
                            DashProjectTypeId={DashProjectTypeId}
                            RoleID={RoleID}
                        />
                        : <></>
                }
            </div>
        </div>



    )
}